<div class="fixed top-5 right-5 z-1000 space-y-3 w-80">
  @for (toast of toasts; track $index) {
  <div
    [ngClass]="{
      'bg-blue-100/80 text-blue-800': toast.data.type === 'info',
      'bg-green-100/80 text-green-800 fill-green-800': toast.data.type === 'success',
      'bg-yellow-100/80 text-yellow-800 fill-yellow-800': toast.data.type === 'warn',
      'bg-red-100/80 text-red-800 fill-red-800': toast.data.type === 'danger'
    }"
    class="rounded-md px-4 py-3 shadow-lg transition-opacity duration-300"
  >
    <div class="flex justify-between w-full">
      <div class="flex items-center gap-1">
        <div [innerHTML]="sanitizedSvg" class="w-5 h-5"></div>
        <span class="text-sm">{{ toast.data.message }}</span>

        <!-- <p>{{ toast.data.type }}</p> -->
      </div>

      <button (click)="remove(toast.id)" class="ml-2 text-lg font-bold">×</button>
    </div>
    <!-- <span class="text-sm">{{ toast.data.message }}</span> -->
  </div>
  }
</div>
